export const corporations = {
  Add_a_New_Company: "Ajouter une nouvelle entreprise",
  Add_Another_Admin: "Ajouter un autre administrateur",
  Add_Company: "Ajouter une entreprise",
  Add_new_company: "Ajouter une nouvelle entreprise",
  Companies: "Entreprises",
  company_management: "gestion d'entreprise",
  Company_name: "Nom de l'entreprise",
  "Created at": "Créé le",
  Edit_Company: "Modifier l'entreprise",
  Name: "Nom",
  Organisation_Admins: "Administrateurs d'organisation",
  Please_enter_the_basic_company_information: "Veuillez saisir les informations de base de l'entreprise",
  Status: "Statut",
  Update_company: "Mettre à jour l'entreprise",
  Use_this_window_to_add_a_new_company_data_on_the_platform:
    "Utilisez cette fenêtre pour ajouter les données d'une nouvelle entreprise sur la plateforme",
  Use_this_window_to_edit_company_data_on_the_platform:
    "Utilisez cette fenêtre pour modifier les données de l'entreprise sur la plateforme",
} as const;
